(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"), require("react-dom"));
	else
		root["fui"] = factory(root["react"], root["react-dom"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__, __WEBPACK_EXTERNAL_MODULE__69514__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 10905:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(96711);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}exports.Fragment=l;exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 29107:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var freeGlobal = __webpack_require__(62718);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 36522:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(96711),
    getRawTag = __webpack_require__(10905),
    objectToString = __webpack_require__(42588);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 38926:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"screenXXs":"320px","screenXs":"480px","screen568":"568px","screen640":"640px","screenS":"768px","screenM":"1024px","screen1126":"1126px","screenL":"1440px"});

/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 42588:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 46103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"screenXXs":"320px","screenXs":"480px","screen568":"568px","screen640":"640px","screenS":"768px","screenM":"1024px","screen1126":"1126px","screenL":"1440px","hidden":"src-styles-helpers-hidden_hidden","invisible":"src-styles-helpers-hidden_invisible","transparent":"src-styles-helpers-hidden_transparent","hiddenSm":"src-styles-helpers-hidden_hiddenSm","invisibleSm":"src-styles-helpers-hidden_invisibleSm","transparentSm":"src-styles-helpers-hidden_transparentSm","hiddenMd":"src-styles-helpers-hidden_hiddenMd","invisibleMd":"src-styles-helpers-hidden_invisibleMd","transparentMd":"src-styles-helpers-hidden_transparentMd","hiddenLg":"src-styles-helpers-hidden_hiddenLg","invisibleLg":"src-styles-helpers-hidden_invisibleLg","transparentLg":"src-styles-helpers-hidden_transparentLg"});

/***/ }),

/***/ 46589:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"clickable":"src-styles-helpers-interaction_clickable","cursorDefault":"src-styles-helpers-interaction_cursorDefault","unselectable":"src-styles-helpers-interaction_unselectable","nonScrollable":"src-styles-helpers-interaction_nonScrollable","outlineNone":"src-styles-helpers-interaction_outlineNone"});

/***/ }),

/***/ 50119:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Modal_ModalContent)
});

// UNUSED EXPORTS: ModalContent, modalContentStyles

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Loader/Spinner/index.ts + 2 modules
var Spinner = __webpack_require__(63393);
// EXTERNAL MODULE: ./src/components/Layout/Div100vh/index.ts + 2 modules
var Div100vh = __webpack_require__(60411);
// EXTERNAL MODULE: ./src/styles/screen/screen.scss
var screen = __webpack_require__(38926);
;// ./src/components/Modal/ModalContent/modalContent.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const modalContent = ({"screenXXs":"320px","screenXs":"480px","screen568":"568px","screen640":"640px","screenS":"768px","screenM":"1024px","screen1126":"1126px","screenL":"1440px","contentWrp":"src-components-Modal-ModalContent-modalContent_contentWrp","modalMobileFooterLayoutWrp":"src-components-Modal-ModalContent-modalContent_modalMobileFooterLayoutWrp","isVisible":"src-components-Modal-ModalContent-modalContent_isVisible","modalMobileFooterLayout":"src-components-Modal-ModalContent-modalContent_modalMobileFooterLayout","preloaderSpinnerOverlay":"src-components-Modal-ModalContent-modalContent_preloaderSpinnerOverlay"});
;// ./src/components/Modal/ModalContent/ModalContent.tsx







const ModalContent = ({ isLoading, footerRef, children }) => {
    // @ts-ignore
    const [footerHeight, setFooterHeight] = (0,external_react_.useState)(footerRef === null || footerRef === void 0 ? void 0 : footerRef.clientHeight);
    const [windowWidth, setWindowWidth] = (0,external_react_.useState)(window.innerWidth);
    const handleResize = (0,external_react_.useCallback)(() => {
        // @ts-ignore
        footerRef && setFooterHeight(footerRef.clientHeight);
        setWindowWidth(window.innerWidth);
    }, [footerRef]);
    (0,external_react_.useEffect)(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);
    (0,external_react_.useEffect)(handleResize, [footerRef, children]);
    return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)("div", { className: classnames_default()(modalContent.contentWrp, 'contentWrp'), style: footerHeight && windowWidth <= parseInt(screen/* default */.A.screenS) ? { paddingBottom: footerHeight } : {}, children: children }), (0,jsx_runtime.jsx)(Spinner.Spinner, { isVisible: isLoading, overlayClassName: classnames_default()({
                    [modalContent.preloaderSpinnerOverlay]: isLoading,
                }), overlay: true }), (0,jsx_runtime.jsx)(Div100vh["default"], { className: classnames_default()(modalContent.modalMobileFooterLayoutWrp, {
                    [modalContent.isVisible]: !!footerHeight && !isLoading,
                }), children: (0,jsx_runtime.jsx)("div", { className: modalContent.modalMobileFooterLayout, style: footerHeight && windowWidth <= parseInt(screen/* default */.A.screenS) ? { height: footerHeight } : {} }) })] }));
};
/* harmony default export */ const ModalContent_ModalContent = (ModalContent);

;// ./src/components/Modal/ModalContent/index.ts



/* harmony default export */ const Modal_ModalContent = (ModalContent_ModalContent);


/***/ }),

/***/ 51633:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","screenXXs":"320px","screenXs":"480px","screen568":"568px","screen640":"640px","screenS":"768px","screenM":"1024px","screen1126":"1126px","screenL":"1440px","isH1":"src-styles-headers_isH1","isH2":"src-styles-headers_isH2","isH3":"src-styles-headers_isH3","disclaimerLogo":"src-styles-headers_disclaimerLogo","disclaimerLogoOnTop":"src-styles-headers_disclaimerLogoOnTop","logoWrapper":"src-styles-headers_logoWrapper"});

/***/ }),

/***/ 51863:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_IconClose)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/components/Icon/BaseIcon/index.ts + 1 modules
var BaseIcon = __webpack_require__(87083);
;// ./src/components/Icon/IconClose/close.inline.svg?raw
/* harmony default export */ const close_inlineraw = ("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M8.58719 7.3231C8.93627 7.67218 8.93627 8.23816 8.58719 8.58724C8.2381 8.93633 7.67213 8.93633 7.32304 8.58724L0.261813 1.52597C-0.0872709 1.17689 -0.0872709 0.61091 0.261813 0.261825C0.610896 -0.0872605 1.17687 -0.0872605 1.52596 0.261825L8.58719 7.3231Z\"/>\n  <path d=\"M1.52595 15.7382C1.17687 16.0873 0.610892 16.0873 0.261808 15.7382C-0.087275 15.3891 -0.0872754 14.8231 0.261808 14.474L7.32304 7.41277C7.67212 7.06368 8.2381 7.06368 8.58718 7.41276C8.93626 7.76185 8.93626 8.32783 8.58718 8.67691L1.52595 15.7382Z\"/>\n  <path d=\"M7.4128 8.6769C7.06372 8.32782 7.06372 7.76184 7.4128 7.41275C7.76189 7.06367 8.32786 7.06367 8.67695 7.41275L15.7382 14.474C16.0873 14.8231 16.0873 15.3891 15.7382 15.7382C15.3891 16.0873 14.8231 16.0873 14.474 15.7382L7.4128 8.6769Z\"/>\n  <path d=\"M14.474 0.261814C14.8231 -0.0872713 15.3891 -0.0872713 15.7382 0.261814C16.0873 0.610899 16.0873 1.17688 15.7382 1.52596L8.67695 8.58723C8.32787 8.93632 7.76189 8.93632 7.41281 8.58723C7.06373 8.23815 7.06373 7.67217 7.41281 7.32309L14.474 0.261814Z\"/>\n</svg>\n");
;// ./src/components/Icon/IconClose/IconClose.tsx



const IconClose = (props) => ((0,jsx_runtime.jsx)(BaseIcon["default"], Object.assign({ icon: close_inlineraw }, props)));
/* harmony default export */ const IconClose_IconClose = (IconClose);

;// ./src/components/Icon/IconClose/index.ts

/* harmony default export */ const Icon_IconClose = (IconClose_IconClose);


/***/ }),

/***/ 60411:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Layout_Div100vh)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
;// ./node_modules/react-div-100vh/dist/esm/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

var warned = false;
var Div100vh = (0,external_react_.forwardRef)(function (_a, ref) {
    var style = _a.style, other = __rest(_a, ["style"]);
    var height = use100vh();
    // TODO: warn only in development
    if (!warned && (style === null || style === void 0 ? void 0 : style.height)) {
        warned = true;
        console.warn('<Div100vh /> overrides the height property of the style prop');
    }
    var styleWithRealHeight = __assign(__assign({}, style), { height: height ? height + "px" : '100vh' });
    return external_react_default().createElement("div", __assign({ ref: ref, style: styleWithRealHeight }, other));
});
Div100vh.displayName = 'Div100vh';
/* harmony default export */ const esm = (Div100vh);
function use100vh() {
    var _a = (0,external_react_.useState)(measureHeight), height = _a[0], setHeight = _a[1];
    var wasRenderedOnClientAtLeastOnce = useWasRenderedOnClientAtLeastOnce();
    (0,external_react_.useEffect)(function () {
        if (!wasRenderedOnClientAtLeastOnce)
            return;
        function setMeasuredHeight() {
            var measuredHeight = measureHeight();
            setHeight(measuredHeight);
        }
        window.addEventListener('resize', setMeasuredHeight);
        return function () { return window.removeEventListener('resize', setMeasuredHeight); };
    }, [wasRenderedOnClientAtLeastOnce]);
    return wasRenderedOnClientAtLeastOnce ? height : null;
}
function measureHeight() {
    if (!isClient())
        return null;
    return window.innerHeight;
}
// Once we ended up on the client, the first render must look the same as on
// the server so hydration happens without problems. _Then_ we immediately
// schedule a subsequent update and return the height measured on the client.
// It's not needed for CSR-only apps, but is critical for SSR.
function useWasRenderedOnClientAtLeastOnce() {
    var _a = (0,external_react_.useState)(false), wasRenderedOnClientAtLeastOnce = _a[0], setWasRenderedOnClientAtLeastOnce = _a[1];
    (0,external_react_.useEffect)(function () {
        if (isClient()) {
            setWasRenderedOnClientAtLeastOnce(true);
        }
    }, []);
    return wasRenderedOnClientAtLeastOnce;
}
function isClient() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}

;// ./src/components/Layout/Div100vh/Div100vh.tsx



class Div100vh_Div100vh extends external_react_.Component {
    constructor(props) {
        super(props);
        /**
         * Fixes bug when on iOS device rotation default libs resize happens before rotation animation end
         */
        this.updateStyleOnRotationEnd = () => {
            // eslint-disable-next-line @typescript-eslint/no-implied-eval
            setTimeout(this.divRef.updateStyle, 420);
        };
        this.divRef = null;
    }
    componentDidMount() {
        window.addEventListener('orientationchange', this.updateStyleOnRotationEnd);
    }
    componentWillUnmount() {
        window.removeEventListener('orientationchange', this.updateStyleOnRotationEnd);
    }
    render() {
        return ((0,jsx_runtime.jsx)(esm, Object.assign({}, this.props, { ref: (ref) => { this.divRef = ref; }, children: this.props.children })));
    }
}
/* harmony default export */ const Layout_Div100vh_Div100vh = (Div100vh_Div100vh);

;// ./src/components/Layout/Div100vh/index.ts

/* harmony default export */ const Layout_Div100vh = (Layout_Div100vh_Div100vh);


/***/ }),

/***/ 62718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 63393:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Spinner: () => (/* reexport */ Loader_Spinner_Spinner)
});

// UNUSED EXPORTS: default, spinnerStyles

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/styles/helpers/hidden.scss
var helpers_hidden = __webpack_require__(46103);
;// ./src/components/Loader/Spinner/spinner.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const spinner = ({"spinner":"src-components-Loader-Spinner-spinner_spinner","isSm":"src-components-Loader-Spinner-spinner_isSm","isXs":"src-components-Loader-Spinner-spinner_isXs","isInline":"src-components-Loader-Spinner-spinner_isInline","isLight":"src-components-Loader-Spinner-spinner_isLight","centered":"src-components-Loader-Spinner-spinner_centered","spinnerOverlay":"src-components-Loader-Spinner-spinner_spinnerOverlay","spinnerOverlayFixed":"src-components-Loader-Spinner-spinner_spinnerOverlayFixed","spinnerOverlayAbsolute":"src-components-Loader-Spinner-spinner_spinnerOverlayAbsolute","spinnerFixed":"src-components-Loader-Spinner-spinner_spinnerFixed","overlay":"src-components-Loader-Spinner-spinner_overlay","overlayTextContainer":"src-components-Loader-Spinner-spinner_overlayTextContainer"});
;// ./src/components/Loader/Spinner/Spinner.tsx
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




const Spinner_Spinner = (_a) => {
    var { isVisible = true, isFixed = false, isSpinnerFixed = false, isAbsolute = false, inline = false, centered = false } = _a, props = __rest(_a, ["isVisible", "isFixed", "isSpinnerFixed", "isAbsolute", "inline", "centered"]);
    const spinnerCls = classnames_default()(spinner.spinner, props.className, {
        [spinner.isXs]: props.size === 'xsmall',
        [spinner.isSm]: props.size === 'small',
        [spinner.isLight]: props.mode === 'light',
        [spinner.isInline]: inline,
        [spinner.centered]: centered,
        [helpers_hidden/* default */.A.hidden]: !isVisible,
        [spinner.spinnerFixed]: isSpinnerFixed,
    });
    const spinnerOverlayCls = classnames_default()(spinner.spinnerOverlay, props.overlayClassName, {
        [helpers_hidden/* default */.A.hidden]: !isVisible,
        [spinner.spinnerOverlayFixed]: isFixed,
        [spinner.spinnerOverlayAbsolute]: isAbsolute,
    });
    const Component = ((0,jsx_runtime.jsx)("div", { className: spinnerCls, "data-test": "loader" }));
    if (props.overlay) {
        return ((0,jsx_runtime.jsx)("div", { className: spinnerOverlayCls, children: Component }));
    }
    return Component;
};
/* harmony default export */ const Loader_Spinner_Spinner = (Spinner_Spinner);

;// ./src/components/Loader/Spinner/index.ts



/* harmony default export */ const Loader_Spinner = ((/* unused pure expression or super */ null && (Spinner)));


/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 68053:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Layout_PortalWrp)
});

// UNUSED EXPORTS: PortalId

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(69514);
var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_);
;// ./src/components/Layout/PortalWrp/constants.ts
/* harmony default export */ const constants = ({
    PORTAL_APP_ID: 'app',
    PORTAL_OVERLAY_ID: 'overlay',
    PORTAL_ID: 'portal',
    PORTAL_POPPER_ID: 'popper',
    PORTAL_NOTIFICATION_ID: 'notification',
});

;// ./src/components/Layout/PortalWrp/PortalWrp.tsx




const PortalWrp = ({ children, portalId = constants.PORTAL_ID, usePortal = true, }) => {
    const [mounted, setMounted] = (0,external_react_.useState)(false);
    (0,external_react_.useEffect)(() => {
        if (usePortal) {
            setMounted(true);
        }
        return () => setMounted(false);
    }, [portalId]);
    if (!usePortal) {
        return children;
    }
    // @ts-ignore
    return mounted ? external_react_dom_default().createPortal(children, document.getElementById(portalId)) : (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ const PortalWrp_PortalWrp = (PortalWrp);

;// ./src/components/Layout/PortalWrp/index.ts



/* harmony default export */ const Layout_PortalWrp = (PortalWrp_PortalWrp);


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 69514:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__69514__;

/***/ }),

/***/ 78148:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(36522),
    isObject = __webpack_require__(95603);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 81301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","i":"src-components-Icon-styles_i","smallIcon":"src-components-Icon-styles_smallIcon","disabled":"src-components-Icon-styles_disabled","greyIcon":"src-components-Icon-styles_greyIcon"});

/***/ }),

/***/ 87083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_BaseIcon)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/styles.scss
var styles = __webpack_require__(81301);
;// ./src/components/Icon/BaseIcon/BaseIcon.tsx
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function BaseIcon(_a) {
    var { icon, src, className, isDisabled = false, onClick = () => null, onMouseEnter = () => null, onMouseLeave = () => null, isSmall = false, isGrey = false, style } = _a, restProps = __rest(_a, ["icon", "src", "className", "isDisabled", "onClick", "onMouseEnter", "onMouseLeave", "isSmall", "isGrey", "style"]);
    const [iconHtml, setIconHtml] = (0,external_react_.useState)(null);
    const isMounted = (0,external_react_.useRef)(false);
    (0,external_react_.useEffect)(() => {
        const controller = new AbortController();
        isMounted.current = true;
        getIconHtml(controller);
        return () => {
            isMounted.current = false;
            controller === null || controller === void 0 ? void 0 : controller.abort();
        };
    }, [icon, src]);
    const getIconHtml = (controller) => __awaiter(this, void 0, void 0, function* () {
        if (src) {
            let iconResponse = yield fetch(src, {
                signal: controller.signal,
            });
            // @ts-ignore
            setIconHtml(yield iconResponse.text());
            // @ts-ignore
            controller = null;
            return;
        }
        let iconHtml = null;
        if (icon) {
            iconHtml = icon;
        }
        // @ts-ignore
        isMounted.current && setIconHtml(iconHtml);
    });
    return ((0,jsx_runtime.jsx)("i", { "data-test": restProps['data-test'], className: classnames_default()(styles/* default */.A.i, className, {
            [styles/* default */.A.disabled]: isDisabled,
            [styles/* default */.A.smallIcon]: isSmall,
            [styles/* default */.A.greyIcon]: isGrey,
        }), 
        // @ts-ignore
        dangerouslySetInnerHTML: { __html: iconHtml }, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style }));
}
/* harmony default export */ const BaseIcon_BaseIcon = (BaseIcon);

;// ./src/components/Icon/BaseIcon/index.ts

/* harmony default export */ const Icon_BaseIcon = (BaseIcon_BaseIcon);


/***/ }),

/***/ 95603:
/***/ ((module) => {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 96711:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29107);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Modal: () => (/* reexport */ Modal_Modal),
  ResponsiveModal: () => (/* reexport */ Modal_ResponsiveModal),
  "default": () => (/* binding */ components_Modal),
  modalStyles: () => (/* reexport */ Modal_modal),
  responsiveModalStyles: () => (/* reexport */ responsiveModal)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/IconClose/index.ts + 2 modules
var IconClose = __webpack_require__(51863);
// EXTERNAL MODULE: ./src/components/Layout/PortalWrp/index.ts + 2 modules
var PortalWrp = __webpack_require__(68053);
// EXTERNAL MODULE: ./src/styles/headers.scss
var headers = __webpack_require__(51633);
// EXTERNAL MODULE: ./src/styles/helpers/hidden.scss
var helpers_hidden = __webpack_require__(46103);
// EXTERNAL MODULE: ./src/styles/helpers/interaction.scss
var interaction = __webpack_require__(46589);
;// ./src/styles/helpers/text.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const helpers_text = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","lowercase":"src-styles-helpers-text_lowercase","uppercase":"src-styles-helpers-text_uppercase","capitalize":"src-styles-helpers-text_capitalize","nowrap":"src-styles-helpers-text_nowrap","base":"src-styles-helpers-text_base","verticalAlignTop":"src-styles-helpers-text_verticalAlignTop","smallText":"src-styles-helpers-text_smallText"});
;// ./src/components/Modal/modal.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const Modal_modal = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","screenXXs":"320px","screenXs":"480px","screen568":"568px","screen640":"640px","screenS":"768px","screenM":"1024px","screen1126":"1126px","screenL":"1440px","modalCloseBtn":"src-components-Modal-modal_modalCloseBtn","modalWrp":"src-components-Modal-modal_modalWrp","withOverlay":"src-components-Modal-modal_withOverlay"});
;// ./src/components/Modal/Modal.tsx










const defaultProps = {
    title: '',
    showOverlay: true,
    closeOnEsc: true,
    className: '',
    modalTitleClassName: '',
    modalBodyClassName: '',
    modalDialogClassName: '',
    hideOnOverlayClicked: false,
    isVisible: false,
    showCloseButton: true,
    isCustomPresentation: false,
};
const isEscapeKey = (event) => {
    let isEscape = false;
    if (event.key !== undefined) {
        isEscape = (event.key === 'Escape' || event.key === 'Esc');
    }
    else {
        isEscape = (event.keyCode === 27);
    }
    return isEscape;
};
const isOpening = (prevState, nextState) => !prevState.isVisible && nextState.isVisible;
const isClosing = (prevState, nextState) => prevState.isVisible && !nextState.isVisible;
class Modal extends external_react_.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: props.isVisible,
            modalContentElement: null,
            clientHeight: 0,
        };
        this.modal = (0,external_react_.createRef)();
        this.modalContent = (0,external_react_.createRef)();
        this._handlerEsc = this._handlerEsc.bind(this);
        this.handleOverlayClick = this.handleOverlayClick.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.handleModalClick = this.handleModalClick.bind(this);
        this.enableEscEventListener = this.enableEscEventListener.bind(this);
        this.disableEscEventListener = this.disableEscEventListener.bind(this);
        this.checkoutRef = this.checkoutRef.bind(this);
    }
    componentDidMount() {
        if (this.state.isVisible) {
            this.enableEscEventListener();
            document.body.classList.add(interaction/* default */.A.nonScrollable);
            if (this.props.afterOpen) {
                this.props.afterOpen();
            }
        }
    }
    // @ts-ignore
    componentDidUpdate(prevProps, prevState) {
        if (this.props.isVisible !== this.state.isVisible) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                isVisible: !!this.props.isVisible,
            });
        }
        if (isOpening(prevState, this.state)) {
            document.body.classList.add(interaction/* default */.A.nonScrollable);
            this.enableEscEventListener();
            if (this.props.afterOpen) {
                this.props.afterOpen();
            }
        }
        if (isClosing(prevState, this.state)) {
            document.body.classList.remove(interaction/* default */.A.nonScrollable);
            this.disableEscEventListener();
            if (this.props.afterClose) {
                this.props.afterClose();
            }
        }
        if (this.state.clientHeight !== document.body.clientHeight) {
            this.setState({ clientHeight: document.body.clientHeight });
        }
    }
    componentWillUnmount() {
        this.disableEscEventListener();
        document.body.classList.remove(interaction/* default */.A.nonScrollable);
    }
    checkoutRef(ref) {
        if (ref)
            this.setState({ modalContentElement: ref });
        else
            this.setState({ modalContentElement: null });
    }
    /**
     * @param {SyntheticEvent} event
     * @private
     */
    _handlerEsc(event) {
        if (isEscapeKey(event) && this.props.closeOnEsc && this.state.isVisible) {
            this.handleCloseClick();
            if (document.activeElement !== document.body) {
                // @ts-ignore
                document.activeElement.blur();
            }
        }
    }
    enableEscEventListener() {
        document.addEventListener('keydown', this._handlerEsc);
    }
    disableEscEventListener() {
        document.removeEventListener('keydown', this._handlerEsc);
    }
    handleModalClick(event) {
        event.stopPropagation();
    }
    handleOverlayClick() {
        if (this.props.hideOnOverlayClicked) {
            this.handleCloseClick();
        }
        if (this.props.onOverlayClicked) {
            this.props.onOverlayClicked();
        }
    }
    handleCloseClick() {
        if (this.props.handleCloseClick) {
            this.props.handleCloseClick();
            return false;
        }
        this.hide();
        if (this.props.onCloseClicked) {
            this.props.onCloseClicked();
        }
        return true;
    }
    show() {
        this.setState({ isVisible: true });
    }
    hide() {
        this.setState({ isVisible: false });
    }
    /**
     * @return {ReactElement}
     */
    render() {
        let title;
        if ((0,external_react_.isValidElement)(this.props.title)) {
            title = this.props.title;
        }
        else {
            title = this.props.title
                ? (0,jsx_runtime.jsx)("span", { className: classnames_default()(headers/* default */.A.isH2, 'modalHeaderTitle'), children: this.props.title })
                : null;
        }
        let modal = ((0,jsx_runtime.jsxs)("div", { ref: this.modal, className: classnames_default()('modalDialog', this.props.modalDialogClassName), onClick: (event) => this.handleModalClick(event), "data-test": this.props.dataTest, children: [(0,jsx_runtime.jsxs)("div", { className: classnames_default()('modalContent', { modalContentWithFooter: !!this.props.footer }), children: [(0,jsx_runtime.jsxs)("div", { className: "modalHeaderWrp", children: [!!title && ((0,jsx_runtime.jsxs)("div", { className: classnames_default()('modalHeader', this.props.modalTitleClassName), "data-test": "modalHeader", children: [title, this.props.customLogoUrl && !this.props.isCustomPresentation && ((0,jsx_runtime.jsx)("img", { src: this.props.customLogoUrl, alt: "logo", className: headers/* default */.A.disclaimerLogo }))] })), this.props.showCloseButton && ((0,jsx_runtime.jsx)("button", { type: "button", className: "modalCloseBtn", onClick: this.handleCloseClick, "data-test": "closeModal", children: (0,jsx_runtime.jsx)(IconClose["default"], {}) }))] }), (0,jsx_runtime.jsx)("div", { className: classnames_default()('modalBody', this.props.modalBodyClassName, helpers_text.base), children: this.props.children })] }), this.props.footer && ((0,jsx_runtime.jsx)("div", { className: "modalFooter", ref: this.props.footerRefCallback, children: this.props.footer }))] }));
        const renderModalContent = () => {
            var _a;
            const shouldRenderAllHeight = this.state.clientHeight !== 0 &&
                ((_a = this.state.modalContentElement) === null || _a === void 0 ? void 0 : _a.clientHeight) > this.state.clientHeight;
            if (this.props.isCustomPresentation) {
                return ((0,jsx_runtime.jsxs)("div", { className: classnames_default()('customModalWrapper', {
                        customModalWrapperDisclaimer: this.props.title === 'Disclaimer',
                        customModalFullHeight: shouldRenderAllHeight,
                    }), ref: this.checkoutRef, children: [this.props.customLogoUrl && this.props.isCustomPresentation && ((0,jsx_runtime.jsx)("div", { className: headers/* default */.A.logoWrapper, children: (0,jsx_runtime.jsx)("img", { src: this.props.customLogoUrl, alt: "logo", className: classnames_default()(headers/* default */.A.disclaimerLogoOnTop, 'disclaimerLogoOnTop') }) })), modal] }));
            }
            return modal;
        };
        let content = renderModalContent();
        const isVisibleCls = { [helpers_hidden/* default */.A.hidden]: !this.state.isVisible };
        let wrapperClasses = classnames_default()(Modal_modal.modalWrp, isVisibleCls, this.props.className);
        if (this.props.showOverlay) {
            wrapperClasses = classnames_default()(wrapperClasses, Modal_modal.withOverlay);
            content = ((0,jsx_runtime.jsx)("div", { className: classnames_default()('modalOverlay', isVisibleCls), onClick: this.handleOverlayClick, "data-no-dnd": "true", children: modal }));
        }
        let render = ((0,jsx_runtime.jsx)("div", { className: wrapperClasses, onContextMenu: this.props.onContextMenu, children: content }));
        return ((0,jsx_runtime.jsx)(PortalWrp["default"], { usePortal: this.props.usePortal, children: render }));
    }
}
Modal.defaultProps = defaultProps;
/* harmony default export */ const Modal_Modal = (Modal);

// EXTERNAL MODULE: ./node_modules/lodash/isFunction.js
var isFunction = __webpack_require__(78148);
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);
// EXTERNAL MODULE: ./src/components/Modal/ModalContent/index.ts + 2 modules
var ModalContent = __webpack_require__(50119);
;// ./src/components/Modal/responsiveModal.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const responsiveModal = ({"screenXXs":"320px","screenXs":"480px","screen568":"568px","screen640":"640px","screenS":"768px","screenM":"1024px","screen1126":"1126px","screenL":"1440px","modalWrp":"src-components-Modal-responsiveModal_modalWrp","modalFooter":"src-components-Modal-responsiveModal_modalFooter","isLoading":"src-components-Modal-responsiveModal_isLoading","contentWrp":"src-components-Modal-responsiveModal_contentWrp"});
;// ./src/components/Modal/ResponsiveModal.tsx
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







const ResponsiveModal = (_a) => {
    var { className = '', isLoading = false, hideOnOverlayClicked = false, closeOnEsc = true, children = null, footer = null } = _a, otherProps = __rest(_a, ["className", "isLoading", "hideOnOverlayClicked", "closeOnEsc", "children", "footer"]);
    // Need to use callback refs to get footer reference in modal content
    // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
    const [footerRef, setFooterRef] = (0,external_react_.useState)(null);
    const handleContextMenu = (0,external_react_.useCallback)((e) => e.stopPropagation(), []);
    return ((0,jsx_runtime.jsx)(Modal_Modal, Object.assign({}, otherProps, (footer ? { footerRefCallback: setFooterRef } : {}), { footer: footer, onContextMenu: handleContextMenu, className: classnames_default()(responsiveModal.modalWrp, className, {
            [responsiveModal.isLoading]: isLoading,
        }), hideOnOverlayClicked: hideOnOverlayClicked && !isLoading, closeOnEsc: closeOnEsc && !isLoading, children: (0,jsx_runtime.jsx)(ModalContent["default"], { isLoading: isLoading, footerRef: footerRef, children: isFunction_default()(children) ? children(setFooterRef) : children }) })));
};
/* harmony default export */ const Modal_ResponsiveModal = (ResponsiveModal);

;// ./src/components/Modal/index.ts





/* harmony default export */ const components_Modal = (Modal_Modal);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map